const regularExpressions = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
  password: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,16}$/,
  dateMonth: /^\d{2}\/\d{2}$/,
  alphabetsNumbers: /^[a-zA-Z0-9 ]*$/,
  name: /^[a-zA-Z0-9 _\-.]*$/,
  address: /^[a-zA-Z0-9/,.; ]+$/,
  alphabetsOnly: /^[^\d!@#$%^&*()_+={}|[\]\\:";'<>?,./]+$/,
  tooManySpace: /  +/g,
  yearMonthDat: /^\d{4}-\d{2}-\d{2}$/,
  phone:/^[1-9]\d*$/,
  gstRegex : /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
  geocodeRegex : /^([-+]?([1-8]?\d(\.\d{1,20})?|90(\.0{1,20})?)),\s*([-+]?((1[0-7]\d|[1-9]?\d)(\.\d{1,20})?|180(\.0{1,20})?))$/
};
export default regularExpressions;
